import { ExclamationCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Button, Card, Col, DatePicker, Form, message, Row, Space, Spin, Tag, Typography } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "../../../../../hooks/useDebounce";
import { formatString } from "../../../../../utils/formatString";
import { calCulateVatInPercent } from "../../../../../utils/helper";
import { isReceiptsModuleEnabled } from "../../../../../utils/isReceiptsModuleEnabled";
import {
  DateField,
  InputField,
  RangePickerField,
  ReactSelectField,
  TextAreaField,
} from "../../../../atoms/FormElement";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms/FormElement/InputNumberField";
import Grid from "../../../../atoms/Grid";
import { getRequiredErrorMessage } from "../../../../libs/form";
import { convertToSpacedLowerCase, DATE_FORMATS, formatCurrency, formatDateByType } from "../../../../libs/utils";
import { ApprovalBar } from "../../../../molecules/ApprovalBar";
import { getConfigData } from "../../../BookingForm/ducks/actions";
import { usePendingRequestsActions } from "../../../PendingApprovalRequets/api/useRefreshPendingRequests";
import { updatePDCStatus } from "../../ducks/actions";
import { postReceiptChequeBounce, replaceReceiptChequeBounce } from "../../Receipts/api/receiptActions";
import {
  bouncedReasons,
  defaultFormVal,
  formattedBankList,
  gridCol,
  paymentModeOptions,
  paymentModeRendering,
  removeEmptyValues,
  visibilityOptions,
} from "../../utili";
import {
  type DepositDestinationOption,
  depositDestinationSelectComponents,
  getDepositToNameForPayload,
} from "./depositDestinationOptions";
import { useBeneficiaryDepositOptions } from "./hook/useBeneficiaryDepositOptions";
import { useInitializePaymentData } from "./hook/useInitializePaymentData";
import { useTotalOverpaymentAmount } from "./hook/useTotalOverpaymentAmount";

var _ = require("lodash");

const defaultVal = defaultFormVal;

const { Paragraph } = Typography;
const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 150,
};

const ModifyPaymentStatus = (props) => {
  const { data, selectedOption, organization } = props;

  const dispatch: any = useDispatch();
  const skipDepositDatePrefill = (() => {
    if (selectedOption !== "confirm_payment") return false;
    const row = data?.params?.data;
    if (!row) return false;
    if (row.paymentReceiptId || row.receiptNo) return true;
    if (Array.isArray(row.paymentReceipts) && row.paymentReceipts.length > 0) return true;
    if (
      Array.isArray(row.subPdcs) &&
      row.subPdcs.some((pdc: any) => pdc?.status?.toLowerCase() === "paid" && pdc?.paymentReceiptId)
    )
      return true;
    return false;
  })();

  const [datePicker, setdatePicker] = useState(
    !skipDepositDatePrefill && data?.params?.data?.depositDate
      ? dayjs(data?.params?.data?.depositDate)
      : dayjs(new Date(Date.now())),
  );
  const [itemStartDate, setItemStartDate] = useState<string | null>(null);
  const [itemEndDate, setItemEndDate] = useState<string | null>(null);
  const { totalOverpaymentRemaining } = useTotalOverpaymentAmount(data?.params?.data?.tenantId);
  let dueDate = dayjs(data?.params?.data?.dueDate);
  let invoiceDate = dayjs(data?.params?.data?.invoiceDate);

  const chequeStatus = data?.params?.data?.chequeStatus?.toLowerCase();
  const currentStatus = data?.params?.data?.currentStaus?.toLowerCase();
  const IspartialPayed = data?.params?.data?.paymentMethodType?.toLowerCase() === "partial";

  const isReceivePaymentAction = selectedOption === "confirm_payment";
  const isEditAction = selectedOption === "edit";
  const isReceiptBounceModal =
    isReceiptsModuleEnabled(organization) &&
    Boolean(data?.params?.data?.paymentReceiptId) &&
    selectedOption === "mark_as_bounced";

  const isReceiptBounceReplace =
    isReceiptsModuleEnabled(organization) &&
    Boolean(data?.params?.data?.paymentReceiptId) &&
    selectedOption === "replace_cheque";
  let checkIsPartial = data?.params?.data?.subPdcs?.some((item) => item?.status?.toLowerCase() === "paid");

  let partialPaidCheque = data?.params?.data?.subPdcs?.filter(
    (item) => item?.status?.toLowerCase() === "paid" && item?.paymentMode?.toLowerCase() === "cheque",
  );

  let makePartialAsBounced = partialPaidCheque?.length > 0 && data?.selectedOption === "mark_as_bounced";
  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);

  const [paymentMode, setPaymentMode] = useState(null);
  const [_bankNameFromDropDown, setBankNameFromDropDown] = useState(null);
  const [rawAmountToPay, setRawAmountToPay] = useState(0);
  const debouncedAmountToPay = useDebounce(rawAmountToPay, 500);
  const [isOverPaymentCredit, setIsOverPamentCredit] = useState(false);
  const [paymentStatusOn, setPaymentStatusOn] = useState(null);
  const [bankList, setBankList] = useState([]);
  const [isApprovalBarVisible, setIsApprovalBarVisible] = useState(false);
  const [pendingSubmitValues, setPendingSubmitValues] = useState<any>(null);
  const configData = useSelector((state: any) => state.dashboard.configData);
  const orgData = useSelector((state: any) => state?.tickets?.orgData);
  const bouncedChequeFee = orgData?.bouncedChequeFee?.amount ?? 0;
  
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm({ defaultValues: defaultVal });

  const [onEditBack, setOnEditBack] = useState(false);
  const [depositTo, setDepositTo] = useState(null);
  const status = getValues()?.status?.value;
  let overPaymentCreditValue: number | null =
    totalOverpaymentRemaining && totalOverpaymentRemaining > 0 ? totalOverpaymentRemaining : null;
  let dueAmount = data?.params?.data?.balance ? data?.params?.data?.balance : data?.params?.data?.totalAmount;
  let twoStepReceiptConfirmation = organization?.twoStepReceiptConfirmation && isReceivePaymentAction;
  let isReceiptsModuleEnabledFlag = isReceiptsModuleEnabled(organization) && isReceivePaymentAction;
  let endPointDecider = isReceiptsModuleEnabledFlag || twoStepReceiptConfirmation;
  let getBouncedCheque = data?.params?.data?.statusHistory?.filter(
    (cheque) => cheque?.status?.toLowerCase() === "bounce",
  );

  const isReplaceChequeAction = selectedOption === "replace_cheque" || data?.params?.data?.bounceToPending;

  // useWatch without a name will watch all fields in the form
  const allValues = useWatch({ control });

  const onBack = () => {
    if (data?.selectedOption === "bounce_cheque_edit" && paymentStatusOn != "bounce") {
      setOnEditBack(!onEditBack);
    } else {
      reset();
      props.onCancel();
    }
  };

  useInitializePaymentData({
    data,
    onEditBack,
    setValue,
    setPaymentStatusOn,
    setPaymentMode,
    setBankNameFromDropDown,
    bouncedChequeFee,
    orgData,
    visibilityOptions,
    paymentModeOptions,
    bouncedReasons,
    formatString,
  });

  const ownerId = data?.params?.data?.ownerId ?? null;
  const { beneficiaryDepositOptions, beneficiaryOptionsLoading } = useBeneficiaryDepositOptions(ownerId);

  useEffect(() => {
    setBankList(formattedBankList(configData));
  }, [configData?.bankList]);

  useEffect(() => {
    const isReceiptFlow = Boolean(data?.params?.data?.paymentReceiptId);
    if (!isReceiptFlow || bankList?.length === 0) return;

    const receiptBankName = data?.params?.data?.paymentDetails?.bankName || data?.params?.data?.bankName;
    if (!receiptBankName) return;

    const normalizedValue = receiptBankName.toLowerCase().replace(/\s+/g, "_");
    const matchedBank = bankList.find(
      (option: any) =>
        option?.value === normalizedValue || option?.label?.toLowerCase() === receiptBankName.toLowerCase(),
    );
    if (matchedBank) {
      setValue("bankName", matchedBank, { shouldValidate: false });
      setBankNameFromDropDown(matchedBank?.value);
    }
  }, [bankList, data, setValue]);

  useEffect(() => {
    if (!["cheque", "credit_card"].includes(paymentMode)) {
      clearErrors("paymentRef");
    }
  }, [paymentMode, clearErrors]);

  useEffect(() => {
    if (paymentMode !== "cheque") {
      clearErrors("chequeDate");
      setValue("chequeDate", null, { shouldValidate: false });
    }
  }, [paymentMode, clearErrors, setValue]);

  useEffect(() => {
    if (!configData?.bankList) {
      dispatch(getConfigData(["bankList"]));
    }

    return () => {
      reset();
    };
  }, []);

  const handleDateRange = (date) => {
    if (date) {
      setdatePicker(dayjs(date));
    }
  };

  const onModalBack = () => {
    setSubmited(false);
    setisError(false);
  };

  const depositDestinationOptions = useMemo(() => {
    return beneficiaryDepositOptions;
  }, [beneficiaryDepositOptions]);

  useEffect(() => {
    if (!beneficiaryDepositOptions.length || !data?.params?.data) return;
    const row = data.params.data;
    const acc = String(row?.beneficiaryAccount ?? row?.depositToAccountNumber ?? "").trim();
    const bank = String(row?.beneficiaryBank ?? row?.depositToBank ?? "").trim();
    const name = String(row?.depositTo ?? row?.beneficiaryName ?? "").trim();
    const match =
      beneficiaryDepositOptions.find(
        (o) => o.accountNumber && acc && o.accountNumber === acc && (!bank || o.bankName === bank),
      ) || beneficiaryDepositOptions.find((o) => name && (o.depositToName === name || o.label === name));
    if (match) {
      setValue("depositTo", match, { shouldValidate: false });
      setValue("depositBank", match.bankName ?? "", { shouldValidate: false });
      setValue("depositAccount", match.accountNumber ?? "", { shouldValidate: false });
      setValue("branch", match.branch ?? "", { shouldValidate: false });
      setValue("swiftCode", match.swiftCode ?? "", { shouldValidate: false });
      setValue("address", match.address ?? "", { shouldValidate: false });
      setDepositTo(match.depositToName ?? "");
    }
  }, [beneficiaryDepositOptions, data?.params?.data, setValue]);

  const depositDestinationSelectStyles = useMemo(
    () => ({
      control: (base) => ({
        ...base,
        minHeight: 44,
      }),
      valueContainer: (base) => ({
        ...base,
        textTransform: "none",
        paddingTop: 2,
        paddingBottom: 2,
      }),
      option: (base, state) => ({
        ...base,
        textTransform: "none",
        paddingTop: 4,
        paddingBottom: 4,
        minHeight: 50,
        display: "flex",
        alignItems: "center",
        ...(state.isSelected
          ? {
              backgroundColor: "#767676",
              color: "#ffffff",
            }
          : state.isFocused
            ? {
                backgroundColor: "#DEEBFF",
                color: "#262626",
              }
            : {
                backgroundColor: "transparent",
                color: "#262626",
              }),
      }),
    }),
    [],
  );

  const onDepositDestinationChange = (e: DepositDestinationOption | null) => {
    if (!e) return;

    setDepositTo(getDepositToNameForPayload(e));
    setValue("depositTo", e);
    setValue("depositBank", e.bankName ?? "");
    setValue("depositAccount", e.accountNumber ?? "");
    setValue("branch", e.branch ?? "");
    setValue("swiftCode", e.swiftCode ?? "");
    setValue("address", e.address ?? "");
  };

  const depositDestinationDisabled =
    data?.params?.data?.currentStaus?.toLowerCase() === "paid" ||
    data?.params?.data?.currentStaus?.toLowerCase() === "settled" ||
    currentStatus === "transfer_in_progress";

  const amountToPay = Number(debouncedAmountToPay) || 0;
  const dueAmountVar = Number(dueAmount) || 0;
  const creditAmount = Number(overPaymentCreditValue) || 0;
  const credit = isOverPaymentCredit ? Number(creditAmount) || 0 : 0;

  const onNoOverPaymentCridet = () => {
    setIsOverPamentCredit(false);
  };

  const calculateRemainingDue = ({
    dueAmountVar,
    credit = 0,
    pay = 0,
  }: {
    dueAmountVar: number;
    credit?: number;
    pay?: number;
  }) => {
    let remaining = dueAmountVar - credit - pay;

    const paymentMethodValue = allValues?.paymentMethodType?.value;

    const isNoPaymentMade = credit === 0 && pay === 0;
    const isDefaultPaymentMethod = !paymentMethodValue || paymentMethodValue === 1;

    if (!IspartialPayed && isNoPaymentMade && isDefaultPaymentMethod) {
      return 0;
    }

    return remaining;
  };

  const remaining = useMemo(() => {
    return calculateRemainingDue({
      dueAmountVar,
      credit: credit,
      pay: amountToPay,
    });
  }, [dueAmountVar, credit, debouncedAmountToPay, isOverPaymentCredit]);

  useEffect(() => {
    const paymentType = allValues?.paymentMethodType?.value;
    if (isOverPaymentCredit && isReceivePaymentAction && paymentType === 1) {
      setValue("dueAmount", 0);
      return;
    }
    setValue("dueAmount", remaining > 0 ? remaining : 0);
  }, [
    remaining,
    credit,
    isOverPaymentCredit,
    amountToPay,
    isReceivePaymentAction,
    setValue,
    allValues?.paymentMethodType?.value,
  ]);

  useEffect(() => {
    if (!isOverPaymentCredit || !isReceivePaymentAction) return;
    const net = Math.max(0, dueAmountVar - (Number(creditAmount) || 0));
    setValue("amountToPay", net);
    setRawAmountToPay(net);
    setValue("dueAmount", 0);
  }, [isOverPaymentCredit, isReceivePaymentAction, dueAmountVar, creditAmount, setValue]);

  const onPaymentMethodTypeChnage = (e) => {
    const dueAmountValue = Number(dueAmount) > 0 ? Number(dueAmount) : 0;
    const creditValue = isOverPaymentCredit ? Number(credit) || 0 : 0;
    const amountWhenFull = creditValue > 0 ? Math.max(0, dueAmountValue - creditValue) : dueAmountValue;
    const balanceWhenFull = isOverPaymentCredit ? amountWhenFull : 0;

    if (e?.value === 1) {
      // Full: when overpayment credit is applied, balance is cleared (0).
      setValue("amountToPay", amountWhenFull);
      setRawAmountToPay(amountWhenFull);
      setValue("dueAmount", balanceWhenFull);
      return;
    }

    if (e?.value === 2) {
      // Partial: amount can be 0 (overpayment credit may cover everything).
      setValue("amountToPay", isOverPaymentCredit ? 0 : undefined);
      setRawAmountToPay(0);
      setValue("dueAmount", isOverPaymentCredit ? amountWhenFull : dueAmountValue);
      return;
    }
    if (e?.value === 3) {
      setValue("amountToPay", amountWhenFull);
      setRawAmountToPay(amountWhenFull);
      setValue("dueAmount", isOverPaymentCredit ? 0 : dueAmountValue);
      return;
    }
  };

  const helpingText = useMemo(() => {
    const paymentType = allValues?.paymentMethodType?.value;
    const overpaymentAmount = remaining < 0 ? Math.abs(remaining) : 0;
    const hasOverpayment = paymentType === 3 && remaining < 0;
    const hasCreditApplied = isOverPaymentCredit && credit > 0;

    // Credit applied + Overpayment (e.g. user selected Full with credit applied)
    if (hasCreditApplied && hasOverpayment) {
      return `Credit applied: ${formatCurrency(credit)}. Overpayment:  ${formatCurrency(overpaymentAmount)}`;
    }

    // Overpayment only
    if (hasOverpayment) {
      return `Overpayment:${formatCurrency(overpaymentAmount)}`;
    }

    // Credit applied only
    if (hasCreditApplied) {
      return overpaymentAmount && overpaymentAmount > amountToPay
        ? `Credit applied: ${formatCurrency(credit)}. Overpayment:  ${formatCurrency(overpaymentAmount)}`
        : `Credit applied: ${formatCurrency(credit)}`;
    }

    return undefined;
  }, [allValues?.paymentMethodType?.value, remaining, isOverPaymentCredit, credit]);

  const getAmountPaymentTypeError = (amountVal, selectedType) => {
    if (amountVal <= 0 || !selectedType) return null;

    const creditVal = isOverPaymentCredit ? Number(creditAmount) || 0 : 0;
    const dueVal = Number(dueAmount) || 0;

    const remaining = dueVal - creditVal - amountVal;

    let expectedType;
    if (remaining < 0) expectedType = 3;
    else if (remaining === 0) expectedType = 1;
    else expectedType = 2;

    if (amountVal <= 0 && !isOverPaymentCredit && selectedType === 3) {
      return getRequiredErrorMessage();
    }
    if (selectedType === expectedType) return null;

    if (remaining < 0) {
      return selectedType === 1 && amountVal < creditVal && isOverPaymentCredit
        ? null
        : "Amount exceeds due amount. Choose Overpayment or reduce the amount.";
    }
    if (remaining > 0) {
      return "Amount is less than due amount. Choose Partial or increase the amount.";
    }
    return "Amount matches due amount. Choose Full payment or adjust amount.";
  };

  useEffect(() => {
    const amountToPayVal = Number(debouncedAmountToPay) || 0;
    const selectedType = allValues?.paymentMethodType?.value;

    if (amountToPayVal <= 0 || !selectedType) {
      clearErrors("amountToPay");
      return;
    }

    const errorMsg = getAmountPaymentTypeError(amountToPayVal, selectedType);
    if (errorMsg) {
      setError("amountToPay", { type: "manual", message: errorMsg });
    } else {
      clearErrors("amountToPay");
    }
  }, [
    debouncedAmountToPay,
    allValues?.paymentMethodType?.value,
    isOverPaymentCredit,
    creditAmount,
    dueAmount,
    setError,
    clearErrors,
  ]);

  const submitUpdate = async (values) => {
    // --- Validation checks ---

    const paymentStatus = values?.paymentStatus?.value;
    const paymentModeType = values?.paymentModeType?.value;
    const reasonValue = values?.reason?.value ?? "";
    const bankNameValue = values?.bankName?.value;
    const isCheque = paymentMode === "cheque";
    const paymentMethodType = values?.paymentMethodType?.value;
    const amountToPayVal = Number(values?.amountToPay) || 0;

    if ((paymentStatus === "bounce" || paymentStatus === "cancelled") && isCheque && !reasonValue) {
      setError("reason", { type: "manual", message: getRequiredErrorMessage() });
      return;
    }

    if (amountToPayVal <= 0 && !isOverPaymentCredit && paymentMethodType === 3) {
      setError("amountToPay", { type: "manual", message: getRequiredErrorMessage() });
      return;
    }
    if (isCheque && !bankNameValue && paymentStatus !== "cancelled") {
      setError("bankName", { type: "manual", message: getRequiredErrorMessage() });
      return;
    }

    if (isReplaceChequeAction && isCheque && !values?.chequeDate) {
      setError("chequeDate", { type: "manual", message: getRequiredErrorMessage() });
      return;
    }

    const amountError = getAmountPaymentTypeError(amountToPayVal, paymentMethodType);
    if (amountError) {
      setError("amountToPay", { type: "manual", message: amountError });
      return;
    }

    // --- Start processing ---
    setLoader(true);

    const { actualAmount, amount, vat } = calCulateVatInPercent(values?.bouncedChequeFee || 0, values?.vat || 0);

    const payload: Record<string, any> = {
      chequeStatus: paymentStatus,
      modeOfPayment: paymentModeType,
      applyOverpaymentCredit: isOverPaymentCredit,
    };

    if (!isReceiptBounceModal && itemEndDate && itemStartDate) {
      payload["itemEndDate"] = itemEndDate;
      payload["itemStartDate"] = itemStartDate;
    }
    if (makePartialAsBounced && values?.subPdcRef?.value) {
      payload["subPdcId"] = values?.subPdcRef?.value;
      payload["documentNo"] = values?.subPdcRef?.label;
    }
    if (values?.bankName?.label && values?.bankName?.label !== "") {
      payload["bankName"] = values?.bankName?.label;
    }

    if (isReplaceChequeAction && isCheque && values?.chequeDate) {
      payload.chequeDate = formatDateByType(values.chequeDate, "api");
    }

    if (!isReceiptBounceModal && paymentMethodType) {
      if (paymentMethodType === 1 && !checkIsPartial) {
        payload["paymentMethodType"] = values?.paymentMethodType?.label?.toLowerCase();
      } else if (paymentMethodType === 1 && checkIsPartial) {
        // ***********
        // As per our meeting discussion, if a user chooses to pay
        //  the last remaining amount in full, your API is still
        // treating it as a partial payment, while on the
        // frontend the user has selected ‘Full’.” just
        // for support to backend logic
        // **********
        payload["paymentMethodType"] = "partial";
        payload["amountToPay"] = Number(values?.amountToPay);
      } else if (paymentMethodType === 2) {
        payload["paymentMethodType"] = values?.paymentMethodType?.label?.toLowerCase();
        payload["amountToPay"] = Number(values?.amountToPay);
      } else if (paymentMethodType === 3) {
        payload["paymentMethodType"] = values?.paymentMethodType?.label?.toLowerCase();
        payload["amountToPay"] = Number(values?.amountToPay);
      }
    }
    // Add VAT-related fields if bouncing from paid → bounce
    if (allValues?.paymentStatus?.value === "bounce") {
      payload["penaltyPaymentMode"] = values?.bouncedChequePaymentMode?.value;
      Object.assign(payload, {
        actualAmount: amount,
        penaltyFee: actualAmount,
        vat,
      });
    }
    if (
      selectedOption === "mark_as_bounced" &&
      values?.bouncedChequePaymentMode?.value === "cheque" &&
      values?.bounceDate
    ) {
      payload["bounceDate"] = formatDateByType(values.bounceDate, "api");
    }

    // Deposit date

    // only depositTo include in payload if user going to pay bugId 14146
    if (paymentStatusOn && paymentStatusOn !== "cancelled" && paymentStatus === "paid") {
      payload.depositDate = formatDateByType(datePicker, "api");
    }

    // Document number handling
    if (!makePartialAsBounced) {
      payload.documentNo = data?.params?.data?.bounceToPending
        ? values?.paymentRefReplaced || null
        : values?.paymentRef;
    }

    // Reason handling
    if (isCheque) {
      if (paymentStatusOn !== "pending") {
        if (paymentStatusOn !== "paid") {
          payload.reason = payload.documentNo ? `${reasonValue} Cheque Number ${payload.documentNo}` : reasonValue;
        }
      }
      if (paymentStatusOn === "cancelled") {
        payload.reason = reasonValue;
      }
      if (paymentStatusOn === "bounce") {
        payload.reason = payload.documentNo ? `${reasonValue} Cheque Number ${payload.documentNo}` : reasonValue;

        if (!makePartialAsBounced) {
          payload.paymentRefReplaced = values?.paymentRefReplaced;
        }
      }
    }

    // Optional note
    if (values?.paymentNote) {
      payload.paymentNote = values.paymentNote;
    }

    // Deposit to case
    const payableTo = data?.params?.data?.payableTo;

    const depositToPayloadName = depositTo || getDepositToNameForPayload(values?.depositTo);
    const depositIban = values?.depositTo?.beneficiaryIBAN ?? data?.params?.data?.beneficiaryIBAN;

    if (depositToPayloadName || values?.depositTo?.value) {
      if (payableTo === "owner" && paymentStatus === "paid") {
        Object.assign(payload, {
          depositTo: depositToPayloadName || values?.depositTo?.value,
          depositToAccountNumber: values?.depositAccount,
          depositToBank: values?.depositBank,
          depositToIBAN: depositIban,
          branch: values?.branch,
          swiftCode: values?.swiftCode,
          address: values?.address,
        });
      } else if (payableTo === "lessor" && paymentStatus === "paid") {
        Object.assign(payload, {
          depositTo: depositToPayloadName || values?.depositTo?.value,
          lessorAccountNumber: values?.depositAccount,
          lessorBankName: values?.depositBank,
          depositToIBAN: depositIban,
          branch: values?.branch,
          swiftCode: values?.swiftCode,
          address: values?.address,
        });
      }
    }

    // --- API call ---
    try {
      let refinedPayload = removeEmptyValues(payload);

      let result: any;
      if (isReceiptBounceModal) {
        try {
          await postReceiptChequeBounce({
            paymentReceiptId: data?.params?.data?.paymentReceiptId,
            penaltyPaymentMode: refinedPayload?.penaltyPaymentMode,
            actualAmount: refinedPayload?.actualAmount,
            penaltyFee: refinedPayload?.penaltyFee,
            vat: refinedPayload?.vat,
            reason: refinedPayload?.reason,
            paymentRefReplaced: refinedPayload?.paymentRefReplaced,
            paymentNote: refinedPayload?.paymentNote,
            ...(refinedPayload?.penaltyPaymentMode === "cheque" && refinedPayload?.bounceDate
              ? { bounceDate: refinedPayload?.bounceDate }
              : {}),
          });
          result = 200;
        } catch (e) {
          result = e;
        }
      } else if (isReceiptBounceReplace) {
        try {
          await replaceReceiptChequeBounce({
            paymentReceiptId: data?.params?.data?.paymentReceiptId,
            bankName: refinedPayload?.bankName,
            documentNo: refinedPayload?.documentNo,
            modeOfPayment: "cheque", // only cheque replacement is allowed
            paymentMethodType: refinedPayload?.paymentMethodType,
            paymentNote: refinedPayload?.paymentNote ?? "",
            ...(refinedPayload?.chequeDate ? { chequeDate: refinedPayload.chequeDate } : {}),
          });
          result = 200;
        } catch (e) {
          result = e;
        }
      } else {
        result = await updatePDCStatus(
          {
            leaseId: data?.params?.data?.leaseId,
            pdcId: data?.params?.data?._id,
          },
          refinedPayload,
          endPointDecider,
        );
      }

      if (result === 200) {
        // reset();
        message.success("Status updated successfully");
        setSubmited(false);
        if (twoStepReceiptConfirmation) {
          await refreshPendingRequests();
        }
        props.onUpdate?.();
      } else {
        const errorMsg = (result as any)?.response?.data?.error || "Something went wrong";
        message.error(errorMsg);
        setErrorMessage(errorMsg);
        setisError(true);
      }
    } catch (error: any) {
      const { response } = error;
      setErrorMessage(response?.data?.error);
    } finally {
      setLoader(false);
    }
  };

  const submitDisabled = () => {
    if ((loader && !isError) || (isApprovalBarVisible && isReceivePaymentAction)) return true;
  };

  const submitLabel = () => {
    if (twoStepReceiptConfirmation) {
      return loader && !isError ? "Loading..." : "Send for Approval";
    } else {
      return loader && !isError ? "Loading..." : "Update";
    }
  };
  const { refreshPendingRequests } = usePendingRequestsActions();

  return (
    <>
      <Card>
        {loader && !isError && (
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Space size={24} className="w-100 text-center" direction="vertical">
                <Spin size="large" className="ag-fontSize32" />
              </Space>
            </Col>
          </Row>
        )}

        <Form layout="vertical" className="bf-main payment-form" onFinish={handleSubmit((e) => submitUpdate(e))}>
          {!submited ? (
            <>
              <ApprovalBar
                isVisible={isApprovalBarVisible && isReceivePaymentAction}
                message="A credit note request is still pending for this invoice. Do you want to continue?"
                containerStyle={{ marginBottom: 24 }}
                primaryButton={{
                  label: "Yes",
                  onClick: async () => {
                    if (!pendingSubmitValues) return;
                    setIsApprovalBarVisible(false);
                    const values = pendingSubmitValues;
                    setPendingSubmitValues(null);
                    await submitUpdate(values);
                    await refreshPendingRequests();
                  },
                }}
                secondaryButton={{
                  label: "No",
                  onClick: () => {
                    setIsApprovalBarVisible(false);
                    setPendingSubmitValues(null);
                  },
                }}
              />

              <Row gutter={24}>
                {overPaymentCreditValue && overPaymentCreditValue > 0 && isReceivePaymentAction && (
                  <Tag className="invoic-fm-status-header" color="cyan">
                    {isOverPaymentCredit ? (
                      <Row>
                        <Col
                          span={24}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Space size={5}>
                            <InfoCircleOutlined /> Overpayment credit of AED {overPaymentCreditValue} has been applied
                            to this invoice.
                            <Button
                              onClick={() => onNoOverPaymentCridet()}
                              className="ef-reject-btn"
                              htmlType="button"
                              style={{ marginLeft: 8 }}
                            >
                              Undo
                            </Button>
                          </Space>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col
                          span={24}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Space size={5}>
                            <InfoCircleOutlined /> &nbsp; This lease has an overpayment credit of AED{" "}
                            {overPaymentCreditValue}. Click (Yes) to apply the credit to this invoice.
                            <Button
                              type="primary"
                              onClick={() => setIsOverPamentCredit(true)}
                              className="ef-approve-btn"
                              htmlType="button"
                              style={{ marginLeft: 8 }}
                            >
                              Yes
                            </Button>
                          </Space>
                        </Col>
                      </Row>
                    )}
                  </Tag>
                )}
                <Col span={24}>
                  {((getBouncedCheque?.length > 0 && paymentStatusOn === "pending") ||
                    (getBouncedCheque?.length > 0 && data?.params?.data?.bounceToPending)) && (
                    <Grid
                      data={getBouncedCheque?.reverse()}
                      columns={gridCol}
                      pagination={false}
                      defaultSettings={gridProps}
                      domLayout={true}
                      height={getBouncedCheque?.length >= 2 ? "200px" : "130px"}
                      maxHeight={"300px"}
                      overlayNoRowsTemplate={"data cannot be found."}
                    />
                  )}
                </Col>

                {!(
                  getBouncedCheque?.length > 0 &&
                  paymentStatusOn === "pending" &&
                  data?.params?.data?.chequeStatus?.toLowerCase() === "bounce"
                ) && (
                  <>
                    <Col span={12}>
                      <Form.Item label={"Due Date"}>
                        <DatePicker
                          disabled={true}
                          style={{ width: "100%" }}
                          defaultValue={dueDate}
                          value={dueDate}
                          format="DD-MM-YYYY"
                          size="middle"
                          picker="date"
                        />
                      </Form.Item>
                    </Col>
                    {!isReceiptBounceModal && !isReceiptBounceReplace && (
                      <Col span={12}>
                        <RangePickerField
                          isRequired={true}
                          control={control}
                          disabled={!isEditAction && !isReceivePaymentAction}
                          label="Invoice Period (From/To)"
                          setValue={setValue}
                          fieldname="invoicePeriod"
                          validate={errors.invoicePeriod && "error"}
                          rules={{ required: getRequiredErrorMessage() }}
                          onDateChange={(date) => {
                            if (date) {
                              setItemStartDate(formatDateByType(date[0], "api"));
                              setItemEndDate(formatDateByType(date[1], "api"));
                            }
                          }}
                          iProps={{
                            format: DATE_FORMATS.display,
                            placeholder: ["Start Date", "End Date"],
                          }}
                          validMessage={errors.invoicePeriod && errors.invoicePeriod.message}
                        />
                      </Col>
                    )}
                    {data?.params?.data?.currentStaus !== "paid" && !isReceiptBounceModal && (
                      <>
                        <Col span={12} style={{ marginTop: "5px" }}>
                          <ReactSelectField
                            fieldname="paymentMethodType"
                            isRequired={true}
                            label="Paid Type"
                            control={control}
                            iProps={{
                              placeholder: "Select one",
                              isDisabled:
                                data?.params?.data?.chequeStatus !== "paid" ||
                                data?.params?.data?.currentStaus === "paid" ||
                                makePartialAsBounced,
                            }}
                            selectOption={[
                              { label: "Full", value: 1 },
                              { label: "Partial", value: 2 },
                              { label: "Overpayment", value: 3 },
                            ]}
                            onChange={(e) => onPaymentMethodTypeChnage(e)}
                            rules={{ required: getRequiredErrorMessage() }}
                            validate={errors.paymentMethodType && "error"}
                            validMessage={errors.paymentMethodType ? errors.paymentMethodType.message : ""}
                          />
                        </Col>

                        <Col span={12} style={{ marginTop: "5px" }}>
                          <InputNumberField
                            fieldname="totalBalance"
                            label="Due Amount"
                            format="currency"
                            control={control}
                            disabled
                            inputNumberProps={{
                              placeholder: "Due Amount",
                              min: 0,
                            }}
                          />
                        </Col>
                        <Col span={12} style={{ marginTop: "5px" }}>
                          <InputNumberField
                            isRequired={!(isOverPaymentCredit && allValues?.paymentMethodType?.value === 2)}
                            fieldname="amountToPay"
                            label="Amount To Pay"
                            format="currency"
                            control={control}
                            disabled={
                              allValues?.paymentMethodType?.value === 1 ||
                              data?.params?.data?.chequeStatus !== "paid" ||
                              makePartialAsBounced
                                ? true
                                : false
                            }
                            inputNumberProps={{
                              placeholder: "Amount To Pay",
                              min: 0,
                            }}
                            onChange={(value) => setRawAmountToPay(Number(value) || 0)}
                            rules={{
                              required:
                                isOverPaymentCredit && allValues?.paymentMethodType?.value === 2
                                  ? false
                                  : getRequiredErrorMessage(),
                              validate: (value) => {
                                const errorMsg = getAmountPaymentTypeError(
                                  Number(value) || 0,
                                  allValues?.paymentMethodType?.value,
                                );
                                return errorMsg || true;
                              },
                            }}
                          />
                        </Col>

                        <Col span={12} style={{ marginTop: "5px" }}>
                          <InputNumberField
                            fieldname="dueAmount"
                            label="Balance"
                            format="currency"
                            control={control}
                            disabled
                            inputNumberProps={{
                              placeholder: "Balance",
                              min: 0,
                            }}
                            formItemProps={{ extra: helpingText }}
                          />
                        </Col>
                      </>
                    )}
                    <Col span={12} style={{ marginTop: "5px" }}>
                      <ReactSelectField
                        fieldname={isReceiptBounceModal ? "bouncedChequePaymentMode" : "paymentModeType"}
                        isRequired={true}
                        label={isReceiptBounceModal ? "Bounced Cheque Payment Mode" : "Payment Mode"}
                        rules={{ required: getRequiredErrorMessage() }}
                        validate={
                          (isReceiptBounceModal ? errors.bouncedChequePaymentMode : errors.paymentModeType) && "error"
                        }
                        validMessage={
                          isReceiptBounceModal
                            ? errors.bouncedChequePaymentMode && errors.bouncedChequePaymentMode.message
                            : errors.paymentModeType && errors.paymentModeType.message
                        }
                        control={control}
                        iProps={{
                          placeholder: isReceiptBounceModal
                            ? "Select bounced cheque payment mode"
                            : "Select payment mode",
                          isDisabled:
                            (chequeStatus === "pending" && currentStatus === "bounce") ||
                            (chequeStatus === "paid" && currentStatus !== "pending") ||
                            currentStatus === "settled" ||
                            data?.params?.data?.bounceToPending ||
                            isReceiptBounceModal,
                        }}
                        selectOption={paymentModeRendering(data)}
                        onChange={(e) => {
                          if (e) {
                            setPaymentMode(e.value);
                          } else {
                            setPaymentMode(null);
                          }
                        }}
                      />
                    </Col>

                    <Col span={12} style={{ marginTop: "5px" }}>
                      <ReactSelectField
                        isRequired={true}
                        key={allValues?.paymentModeType?.value}
                        fieldname="paymentStatus"
                        label={`Payment Status (${convertToSpacedLowerCase(currentStatus)})`}
                        selectOption={[]}
                        control={control}
                        iProps={{
                          placeholder: "Select payment status",
                          isDisabled: true,
                        }}
                        placeholder="Select One"
                        rules={{ required: getRequiredErrorMessage() }}
                        validate={errors.paymentStatus && "error"}
                        validMessage={errors.paymentStatus && errors.paymentStatus.message}
                        onChange={(e) => {
                          if (e) {
                            if (e.value === "cancelled") {
                              setValue(
                                "reason",
                                {
                                  value: bouncedReasons[0]?.value,
                                  label: bouncedReasons[0]?.label,
                                },
                                { shouldValidate: false },
                              );
                            }
                            setPaymentStatusOn(e.value);
                            clearErrors();
                          }
                        }}
                      />
                    </Col>

                    {paymentStatusOn && paymentStatusOn !== "cancelled" && (
                      <Col span={12}>
                        {makePartialAsBounced ? (
                          <ReactSelectField
                            isRequired={true}
                            fieldname="subPdcRef"
                            label="Payment Ref"
                            control={control}
                            setValue={setValue}
                            iProps={{
                              placeholder: "Select Payment Ref",
                              // isDisabled: data?.params?.data?.bounceToPending,
                            }}
                            rules={{ required: getRequiredErrorMessage() }}
                            selectOption={partialPaidCheque?.map((pdc) => {
                              return {
                                label: pdc?.documentNo,
                                value: pdc?.subPdcId,
                              };
                            })}
                            validate={errors.subPdcRef && errors.subPdcRef}
                            validMessage={errors.subPdcRef && errors.subPdcRef.message}
                          />
                        ) : (
                          <InputField
                            key={`${allValues?.paymentStatus?.value}-${paymentStatusOn}-${paymentMode}`} // dynamic key okay
                            fieldname="paymentRef"
                            label="Payment Ref"
                            isRequired={paymentMode ? ["cheque", "credit_card"].includes(paymentMode) : false}
                            control={control}
                            disabled={
                              isReceiptBounceModal ||
                              (getBouncedCheque?.length > 0 &&
                                paymentStatusOn === "pending" &&
                                data?.params?.data?.chequeStatus?.toLowerCase() === "bounce") ||
                              data?.params?.data?.currentStaus?.toLowerCase() === "paid" ||
                              data?.params?.data?.bounceToPending ||
                              data?.params?.data?.currentStaus?.toLowerCase() === "settled"
                            }
                            iProps={{
                              placeholder: "Enter Payment Ref",
                            }}
                            initValue=""
                            rules={{
                              required: ["cheque", "credit_card"].includes(paymentMode)
                                ? getRequiredErrorMessage()
                                : false,
                            }}
                            validate={!!errors.paymentRef && "error"}
                            validMessage={errors.paymentRef?.message}
                          />
                        )}
                      </Col>
                    )}

                    {paymentStatusOn && paymentStatusOn !== "cancelled" && (
                      <Col span={12}>
                        {
                          <ReactSelectField
                            key={paymentMode}
                            fieldname="bankName"
                            isRequired={paymentMode === "cheque" ? true : false}
                            label={"Bank Name"}
                            rules={{
                              required: paymentMode === "cheque" ? getRequiredErrorMessage() : false,
                            }}
                            iProps={{
                              isDisabled:
                                (getBouncedCheque?.length > 0 &&
                                  paymentStatusOn === "pending" &&
                                  data?.params?.data?.chequeStatus?.toLowerCase() === "bounce" &&
                                  data?.params?.data?.chequeStatus?.toLowerCase() === "paid") ||
                                data?.params?.data?.currentStaus?.toLowerCase() === "paid" ||
                                data?.params?.data?.chequeStatus?.toLowerCase() === "bounce" ||
                                data?.params?.data?.bounceToPending ||
                                data?.params?.data?.currentStaus?.toLowerCase() === "settled",
                            }}
                            validate={paymentMode === "cheque" ? errors.bankName && "error" : false}
                            validMessage={paymentMode === "cheque" ? errors.bankName && errors.bankName.message : false}
                            control={control}
                            placeholder={"Enter Bank Name"}
                            selectOption={bankList || []}
                            onChange={(e) => {
                              setBankNameFromDropDown(e.value);
                            }}
                            initValue={null}
                          />
                        }
                      </Col>
                    )}

                    {paymentStatusOn && paymentStatusOn === "paid" && paymentMode === "cheque" && (
                      <Col span={12}>
                        <Form.Item label={"Deposit Date"}>
                          <DatePicker
                            disabled={data?.params?.data?.currentStaus?.toLowerCase() === "paid"}
                            style={{ width: "100%" }}
                            defaultValue={datePicker}
                            value={datePicker}
                            format="DD-MM-YYYY"
                            // disabledDate={(current) => {
                            //   const isPastDate = current && current.valueOf() > Date.now();
                            //   return isPastDate;
                            // }}
                            size="middle"
                            picker="date"
                            onChange={handleDateRange}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {/*  for deposit To section when payment status is paid start from here */}

                    {(allValues?.paymentStatus?.value === "paid" || paymentStatusOn === "paid") && (
                      <Col span={24}>
                        <ReactSelectField
                          fieldname="depositTo"
                          label="Deposit To"
                          control={control}
                          setValue={setValue}
                          style={{ width: "100%" }}
                          components={depositDestinationSelectComponents}
                          onChange={(e) => onDepositDestinationChange(e)}
                          isRequired={!depositDestinationDisabled && depositDestinationOptions.length > 0}
                          rules={
                            !depositDestinationDisabled && depositDestinationOptions.length > 0
                              ? { required: getRequiredErrorMessage() }
                              : undefined
                          }
                          iProps={{
                            placeholder: "Select deposit destination",
                            isDisabled: depositDestinationDisabled,
                            isLoading: beneficiaryOptionsLoading,
                            styles: depositDestinationSelectStyles,
                          }}
                          selectOption={depositDestinationOptions}
                        />
                      </Col>
                    )}
                  </>
                )}
                {(isReceiptBounceModal ||
                  (paymentMode === "cheque" &&
                    (paymentStatusOn === "bounce" ||
                      paymentStatusOn === "cancelled" ||
                      data?.params?.data?.chequeStatus?.toLowerCase() === "cancelled"))) && (
                  <Col span={12}>
                    <ReactSelectField
                      fieldname="reason"
                      label="Reason"
                      validate={errors.reason && "error"}
                      control={control}
                      iProps={{
                        placeholder: "Select reason",
                        isDisabled: data?.params?.data?.bounceToPending,
                      }}
                      selectOption={bouncedReasons}
                      isRequired={true}
                      rules={{ required: getRequiredErrorMessage() }}
                      validMessage={errors.reason && errors.reason.message}
                    />
                  </Col>
                )}
                {status !== "paid" && paymentMode !== "cheque" && !isReceiptBounceModal && <Col span={12}></Col>}

                {(isReceiptBounceModal ||
                  (paymentMode === "cheque" &&
                    (allValues?.paymentStatus?.value === "bounce" || paymentStatusOn === "bounce"))) &&
                  !isReceiptBounceModal && (
                    <Col span={12}>
                      <ReactSelectField
                        fieldname="bouncedChequePaymentMode"
                        label="Bounced Cheque Payment Mode"
                        control={control}
                        iProps={{
                          placeholder: "Enter Payment Mode",
                          isDisabled: data?.params?.data?.bounceToPending,
                        }}
                        selectOption={paymentModeOptions}
                      />
                    </Col>
                  )}

                {(isReceiptBounceModal ||
                  (paymentMode === "cheque" &&
                    (allValues?.paymentStatus?.value === "bounce" || paymentStatusOn === "bounce"))) && (
                  <>
                    <Col span={12}>
                      <InputField
                        fieldname="bouncedChequeFee"
                        label={"Bounced Cheque Fee"}
                        control={control}
                        disabled //={data?.params?.data?.bounceToPending}
                        iProps={{
                          placeholder: "Bounced Cheque Fee",
                          min: 0,
                          type: "number",
                        }}
                        initValue={isReceiptBounceModal ? data?.params?.data?.penaltyFee || "" : bouncedChequeFee || 0}
                      />
                    </Col>

                    <Col span={12}>
                      <InputField
                        fieldname="vat"
                        label={"Vat %"}
                        control={control}
                        disabled //={data?.params?.data?.bounceToPending}
                        iProps={{
                          placeholder: "Vat",
                          min: 0,
                          type: "number",
                        }}
                      />
                    </Col>
                  </>
                )}

                {selectedOption === "mark_as_bounced" && allValues?.bouncedChequePaymentMode?.value === "cheque" && (
                  <Col span={12}>
                    <DateField
                      fieldname="bounceDate"
                      label="Bounce Date"
                      control={control}
                      isRequired
                      rules={{ required: getRequiredErrorMessage() }}
                      validate={errors?.bounceDate && "error"}
                      validMessage={errors?.bounceDate?.message}
                      iProps={{ disabledDate: (current) => current && current.valueOf() > Date.now() }}
                    />
                  </Col>
                )}

                {!(
                  getBouncedCheque?.length > 0 &&
                  paymentStatusOn === "pending" &&
                  !data?.params?.data?.bounceToPending
                ) && (
                  <Col span={24}>
                    <TextAreaField
                      disabled={data?.params?.data?.bounceToPending}
                      label={"Note"}
                      fieldname="paymentNote"
                      iProps={{ placeholder: "Note...." }}
                      initValue=""
                      setValue={setValue}
                      control={control}
                      valueGot={data?.params?.data?.paymentNote}
                    />
                  </Col>
                )}

                {((getBouncedCheque?.length > 0 &&
                  paymentStatusOn === "pending" &&
                  data?.params?.data?.chequeStatus?.toLowerCase() === "bounce") ||
                  data?.params?.data?.bounceToPending) && (
                  <>
                    <Col span={24}>
                      <h3>Replaced Payment Details</h3>
                    </Col>

                    <Col span={12}>
                      <ReactSelectField
                        fieldname="paymentModeType"
                        key={paymentStatusOn}
                        validate={errors.paymentModeType && "error"}
                        isRequired={true}
                        label="Payment Mode"
                        control={control}
                        iProps={{
                          placeholder: "Select payment mode",
                        }}
                        rules={{ required: getRequiredErrorMessage() }}
                        validMessage={errors.paymentModeType && errors.paymentModeType.message}
                        selectOption={paymentModeOptions}
                        onChange={(e) => {
                          if (e) {
                            setPaymentMode(e.value);
                          } else {
                            setPaymentMode(null);
                          }
                          if (e?.value !== "cheque") {
                            setValue("chequeDate", null, { shouldValidate: false });
                            clearErrors("chequeDate");
                          }
                        }}
                      />
                    </Col>

                    {isReplaceChequeAction && paymentMode === "cheque" ? (
                      <Col span={12}>
                        <DateField
                          fieldname="chequeDate"
                          label="Cheque Date"
                          control={control}
                          setValue={setValue}
                          isRequired
                          rules={{ required: getRequiredErrorMessage() }}
                          validate={errors?.chequeDate && "error"}
                          validMessage={errors?.chequeDate?.message}
                        />
                      </Col>
                    ) : (
                      <Col span={12}></Col>
                    )}

                    <Col span={12}>
                      {
                        <InputField
                          key={allValues?.paymentStatus?.value + (paymentStatusOn ?? "")}
                          fieldname="paymentRefReplaced"
                          label={"Payment Ref"}
                          isRequired={paymentMode === "cheque" ? true : false}
                          control={control}
                          iProps={{
                            placeholder: "Enter Payment Ref",
                          }}
                          validate={errors.paymentRefReplaced && "error"}
                          validMessage={errors.paymentRefReplaced && errors.paymentRefReplaced.message}
                          rules={{ required: getRequiredErrorMessage() }}
                          initValue=""
                        />
                      }
                    </Col>

                    <Col span={12}>
                      <ReactSelectField
                        fieldname="bankName"
                        isRequired={true}
                        label={"Bank Name"}
                        control={control}
                        placeholder={"Enter Bank Name"}
                        iProps={{
                          isDisabled: data?.params?.data?.chequeStatus?.toLowerCase() === "paid",
                        }}
                        selectOption={bankList || []}
                        initValue={""}
                        onChange={(e) => {
                          setBankNameFromDropDown(e.value);
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>
              <Row gutter={24} justify="space-between">
                <Col>
                  <Button
                    className="ef-discard-btn"
                    onClick={() => onBack()}
                    disabled={isApprovalBarVisible && isReceivePaymentAction}
                  >
                    Back
                  </Button>
                </Col>

                <Col>
                  {
                    <Button disabled={submitDisabled()} type="primary" className="ef-approve-btn" htmlType="submit">
                      {submitLabel()}
                    </Button>
                  }
                </Col>
              </Row>
            </>
          ) : (
            isError && (
              <>
                <Row gutter={[24, 24]}>
                  <Col span={24}>
                    <Space size={24} className="w-100 text-center" direction="vertical">
                      <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                      <Paragraph className="ag-error fontWeight600 mb-0">{errorMessage}</Paragraph>
                    </Space>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={24}>
                    <Button className="ef-discard-btn" htmlType="button" onClick={() => onModalBack()}>
                      Back
                    </Button>
                  </Col>
                </Row>
              </>
            )
          )}
        </Form>
      </Card>
    </>
  );
};

export default React.memo(ModifyPaymentStatus);
